// Client-side image resize to control payload size before upload.
// Reads a File, decodes it onto a canvas, scales so the longest edge <= maxDim,
// re-encodes as JPEG at given quality. Returns a base64 data URI.
export async function fileToResizedDataUri(file, { maxDim = 1600, quality = 0.82 } = {}) {
  if (!file.type.startsWith("image/")) {
    throw new Error("Only image files are supported.");
  }
  const dataUrl = await new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(r.result);
    r.onerror = () => reject(r.error);
    r.readAsDataURL(file);
  });
  const img = await new Promise((resolve, reject) => {
    const el = new Image();
    el.onload = () => resolve(el);
    el.onerror = () => reject(new Error("Could not read image."));
    el.src = dataUrl;
  });
  let { width, height } = img;
  const longest = Math.max(width, height);
  if (longest > maxDim) {
    const r = maxDim / longest;
    width = Math.round(width * r);
    height = Math.round(height * r);
  }
  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0, width, height);
  return canvas.toDataURL("image/jpeg", quality);
}

export function dataUriByteLength(uri) {
  const comma = uri.indexOf(",");
  const b64 = comma >= 0 ? uri.slice(comma + 1) : uri;
  return Math.floor((b64.length * 3) / 4);
}
